import angular from "angular";
import { directiveFactory } from "../angular-core";

export class NgTitleDirective implements ng.IDirective {
    static componentName: string = "ngTitle";
    static $inject = ["$interpolate", "$parse"];
    restrict = "A";
    link = (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes) => {
        scope.$watch(attrs.ngTitle, function (newValue: $TSFixMe, oldValue: $TSFixMe) {
            refresh(element, newValue);
        });
        scope.$on("LanguageChanged", () => {
            refresh(element, this.$parse(attrs.ngTitle)(scope));
        });

        const refresh = (element: $TSFixMe, ngTitleAttrValue: $TSFixMe) => {
            var value = this.$interpolate(ngTitleAttrValue);
            element.attr("title", value(null));
        };
    };
    constructor(protected $interpolate: ng.IInterpolateService, protected $parse: ng.IParseService) {}
}

angular
    .module("topline.directives")
    .directive(NgTitleDirective.componentName, directiveFactory(NgTitleDirective));